<template>
    <HeadlineComponent>Crew mit Ticket verbinden</HeadlineComponent>
    Eine sekunde bitte!
  </template>
  
  <script>
  import {mapActions} from "pinia";
  import {useAlertsStore} from "@/stores/alerts.js";
  import HeadlineComponent from "@/components/HeadlineComponent.vue";
  import eventService from "@/services/event.service";
  import * as Sentry from '@sentry/vue';
  
  export default {
      name: "ConnectUserView",
      methods: {
          ...mapActions(useAlertsStore, { addAlert: "add" }),
      },
      async beforeMount() {
          try {
              let result = await eventService.connect(this.$route.params.event, this.$route.params.user, this.$route.params.ticket);
              this.addAlert("sucess", result.data.message);
              window.scrollTo(0, 0);
              this.$router.push("/user");
          }
          catch (e) {
              if (e) {
                   Sentry.captureException(e);
                  this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
                  this.$router.push("/user");
                  window.scrollTo(0, 0);
              }
          }
      },
      components: { HeadlineComponent }
  }
  </script>
  
  <style scoped>
  
  </style>